import { renderToolsComponent } from './components/map-tools-control';
import { renderMarkersToolsControl } from './components/radar';
import MarkersService from './providers/markers-service.js';
import RoutesService from './providers/routes-service';
import RoutesServiceNY from './providers/routes-service-ny';
import Map from './providers/map-singleton';
import GeoService from './providers/geo-service';
import Radar from './components/radar/radar';
import './style/base.scss';
import { renderNewYearTrack } from './components/new-year';

export default class FortMap {
    constructor(renderTo, settings) {
        this.settings = settings;
        this.map = new Map(renderTo, settings);
        this.map.initMeasure();
        this.map.initAddressService();
        this.markersService = new MarkersService(this.map, settings);
        this.routesService = new RoutesService(this.map);
        this.routesServiceNY = new RoutesServiceNY(this.map);
        this.geoService = new GeoService(this.map, settings);
        this.selectedObjectId = 0;

        this.radar = new Radar(this.map);
        if (this.radar.isExist()) {
            renderMarkersToolsControl( this.map, 
                                        this.markersService, 
                                        this.routesService,
                                        this.radar, 
                                        settings.updateTimeoutValue, 
                                        settings.objectsListBlock
            );
            this.settings.toolsControl.isSwitchOnAddressDetect = false;
            this.settings.toolsControl.isSwitchOnPrint = false;
        }

        if (!this.settings.toolsControl.isHidden) {
            renderToolsComponent(this.map, this.markersService, this.geoService, this.settings.toolsControl);
        }

        renderNewYearTrack(this.map, this.routesServiceNY, this.settings.toolsControl);
    }

    paintTrack(routeInfo, options) {
        this.routesService.setRouteOnMap(routeInfo, options);
    }

    clearTrack(oid) {
        this.routesService.clearRoute(oid);
    }

    getZoom() {
        return this.map.getZoom();
    }

    getCenter() {
        return this.map.getCenter();
    }

    getSelectedLayer() {
        return this.map.selectedLayer.name;
    }

    setCenter(latLng) {
        if (latLng == null || typeof latLng == 'undefined') {
            return;
        }
        try {
            this.map.panTo(latLng);
        }
        catch (error) {
            console.error('setCenter', error);
        }
    }

    setObjects(listOfObjects, notClusteringZoom = 20) {
        const defaultRoutes = this.routesService.routesDictionary.filter(route => route.type == 'default');
        this.markersService.setObjectsOnMap({ listOfObjects, notClusteringZoom, defaultRoutes, selectedObjectId: this.selectedObjectId });
    }

    updateObjects(listOfObjects) {
        if (listOfObjects.result == 'Ok') {
            this.markersService.updateObjects(listOfObjects.objs);
        }
    }

    selectObject(oid) {
        this.markersService.setMapOnMarker(oid);
        this.routesService.selectRoute(oid);
        this.selectedObjectId = oid;
        const event = new CustomEvent('map:objectSelected', { detail: { objectId: oid } });
        document.dispatchEvent(event);
    }

    editZone(id) {
        return this.geoService.editZone(id);
    }

    getTilesStatistic() {
        return this.map.getTilesStatistic();
    }

    updateMinVisibleZoomGeofenceTooltip(minZoom) {
        this.settings.geofenceTooltip.minVisibleZoom = minZoom;
        this.map.options.geofenceTooltip.minVisibleZoom = minZoom;
    }

    onObjectFollow(objectId, track) {
        this.markersService.setMapOnMarker(objectId);
        this.routesService.setObjectTailTrack(objectId, track);
    }

    onObjectStopFollow() {
        this.routesService.removeObjectTailTrack();
    }
}
